import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import normalizeInternalLink from 'commons/normalizeInternalLink';
import IconArrowRightSimple from 'components/icons/iconArrowRightSimple';
import ProductImage from './ProductImage';
const ShopPageListItem = t0 => {
  const $ = _c(13);
  const {
    title,
    link,
    product
  } = t0;
  let t1;
  if ($[0] !== link) {
    t1 = normalizeInternalLink(link);
    $[0] = link;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== product) {
    t2 = <div className="items-center flex h-[38px] mr-7 transition-[all_.25s_ease-in-out] w-[38px]"><ProductImage {...product} forceFallback={true} layout="thumbnail" /></div>;
    $[2] = product;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== title) {
    t3 = <div className="text-[#4a4a4a]">{title} </div>;
    $[4] = title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="flex flex-row items-center">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IconArrowRightSimple className="md:hidden" />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t4) {
    t6 = <li className="[border-bottom:1px_solid_#f1f1f1] list-none m-0 px-0 py-[5px] max-[767px]:pl-6 max-[767px]:pr-6 last:[border-bottom:0]"><Link to={t1} className="block max-[767px]:flex max-[767px]:flex-row max-[767px]:justify-between max-[767px]:items-center hover:!no-underline">{t4}{t5}</Link></li>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
ShopPageListItem.propTypes = {
  title: PropTypes.string,
  link: PropTypes.string,
  product: PropTypes.object
};
export default ShopPageListItem;